import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import {
  attachmentModule,
  preview,
  viewControlInTreatment,
  wasmModule,
} from "@/gluelayer"
import { Box, Button, Grid, Tooltip, Typography } from "@mui/material"
import { useEffect, useRef } from "react"
import { singleData } from "@/UDTreat/UDesign/Attachments/columns"
import AttachmentWarning from "@/UDTreat/UDesign/Attachments/AttachmentWarning"
import { fetchClinicalSettings, updateClinicalSettings } from "@/core/app/slices/user/userApis"

const { drawAuxullarties } = viewControlInTreatment

export const AttachmentList = ({
  showSave = false,
  onSaveSuccess,
}: {
  showSave?: boolean
  onSaveSuccess?: () => void
}) => {
  const { attachInit } = useAppSelector((state: RootState) => state.userService)
  const DefineAttachment = useAppSelector((state: RootState) => state.userService.clinicalSettings.DefineAttachment)
  const dispatch = useAppDispatch()
  const DefineAttachmentRef = useRef(DefineAttachment)

  // Keep ref in sync with Redux state
  useEffect(() => {
    DefineAttachmentRef.current = DefineAttachment
  }, [DefineAttachment])

  useEffect(() => {

    if (!attachInit) return

    setTimeout(() => {
      const auxTmp = [{ type: "Normal", elements: [] }] as any
      singleData.subData.map((item) => {
        item.data.map((i) => {
          const ele = document.getElementById(`${i.name}${i.key}`)
          auxTmp[0].elements.push([i.id, ele])
        })
      })

      const canvasRoot = document.getElementById("scrollWrap")
      drawAuxullarties(canvasRoot, auxTmp)
    }, 10)
  }, [])

  const onSelectAux = (id: number) => {
    attachmentModule.setAttachmentSelectLibID(id)
  }

  const AuxWindow = (name: string, AuxDatas, key: string | number) => {
    return (
      <Grid container item xs={12} key={key}>
        <Grid item xs={12}>
          <Typography variant="h6"> {name} </Typography>
        </Grid>
        {AuxDatas.map((auxData) => {
          return (
            <Grid item xs={3} key={auxData.key}>
              <Tooltip title={auxData.name}>
                <Box
                  sx={{
                    width: "64px",
                    height: "64px",
                    border: 1,
                    cursor: "pointer",
                  }}
                  id={`${auxData.name}${auxData.key}`}
                  onClick={() => {
                    onSelectAux(+auxData.id)
                  }}
                />
              </Tooltip>
            </Grid>
          )
        })}
      </Grid>
    )
  }

  return (
    <>
      <Box
        id="scrollWrap"
        sx={{
          width: "320px",
          position: "relative",
          backgroundColor: "#FAFAFA",
          paddingLeft: 1,
          paddingBottom: 1,
          // visibility: attachInit ? "visible" : "hidden",
        }}
      >
        <Grid container alignItems={"center"} spacing={0.25}>
          {singleData.subData.map((subdata) => {
            return AuxWindow(subdata.name, subdata.data, subdata.name)
          })}
        </Grid>

        {showSave && (
          <Button
            sx={{ mt: 2, backgroundColor: "#42A5F5" }}
            variant="contained"
            onClick={() => {
              const settingJson =
                attachmentModule.GetSingleAttachmentSettingJson()
              dispatch(
                updateClinicalSettings({
                  DefineAttachment: JSON.parse(settingJson),
                }),
              )
                .then(() => dispatch(fetchClinicalSettings()))
                .then(() => {
                  onSaveSuccess?.()
                  // Sync the latest data from Redux to wasm to prevent false change detection
                  // Use setTimeout to ensure we get the updated Redux state after re-render
                  setTimeout(() => {
                    attachmentModule.SetSingleAttachmentSettingJson(
                      JSON.stringify(DefineAttachmentRef.current),
                    )
                  }, 0)
                })
                .catch((err) => {
                  alert(" Failed to save settings: " + err.message)
                })
            }}
          >
            Save
          </Button>
        )}
      </Box>
      <AttachmentWarning switchViewEdit={attachInit} />
    </>
  )
}
